import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoleGuard } from 'src/app/shared/guards/role.guard';
import { PartnershipDetailComponent } from './partnership-detail/partnership-detail.component';
import { PartnershipFormComponent } from './partnership-form/partnership-form.component';
import { PartnershipComponent } from './partnership.component';

const routes:Routes=[
  {path:'',redirectTo:'list',pathMatch:'full'},
  {path:'list',component:PartnershipComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin",'manager','userClube']}},
  {path:'new',component:PartnershipFormComponent,canActivate:[RoleGuard],data:{roles: ["admin"]}},
  {path:'edit',component:PartnershipFormComponent,canActivate:[RoleGuard],data:{roles: ["admin"]}},
  {path:'detail',component:PartnershipDetailComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin",'manager','userClube']}}
]
  // o Administrador Khuzela faz CRUD
  // o Utilizador Khuzela  só Lê
  // o Manager do Clube só Lê
  // o Utilizador do Clube só Lê

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports:[
    RouterModule
  ]
})
export class PartinershipRoutingModule { }
